/* eslint-disable */
import { FIELD } from "@/data/constants";

export default [
  {
    fieldType: FIELD.TEXT.FIELDSETHEADING,
    name: "immiCardTitle",
    label: "ImmiCard"
  },
  {
    fieldType: FIELD.TEXT.PARAGRAPH,
    name: "immiCardIntroduction",
    description: [
      "Enter all fields as they appear on your ImmiCard."
    ]
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_immicarddvs_givenname",
    label: "First name",
    fieldRequired: true,
    validation: { required: true, max: 49 }
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_immicarddvs_middlename",
    label: "Middle name",
    validation: { max: 49 }
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_immicarddvs_surname",
    label: "Last name",
    fieldRequired: true,
    validation: { required: true, max: 49 }
  },
  {
    fieldType: FIELD.TEXT.FIELDDATEHEADING,
    label: "Date of birth",
    fieldRequired: true
  },
  {
    fieldType: FIELD.INPUT.DATE,
    name: "greenid_immicarddvs_dob",
    label: "Date of birth",
    disabled: true,
    hint: "For example, 31 3 1979",
    validation: { required: true },
    fromYear: 1900,
    toYear: 2021
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_immicarddvs_card_number",
    label: "ImmiCard number",
    fieldRequired: true,
    validation: { required: true, regex: /^[A-Za-z]{3}\d{6}$/ },
    hint: "Enter all letters and numbers as they appear on your ImmiCard."
  },
  {
    fieldType: FIELD.FORM.DIVIDER
  },
  {
    fieldType: FIELD.INPUT.CHECK,
    name: "greenid_immicarddvs_tandc",
    label: "Authorisation/Consent",
    validation: { required: true },
    options: [
      {
        value: "on",
        text: "I confirm that I am authorised to provide the personal details presented and I consent to my information being checked with the document issuer or official record holder via third party systems for the purpose of confirming my identity."
      }
    ]
  }
];
